import BacklogHeader from './BacklogHeader';
import BacklogContainer from './BacklogContainer';

const Backlog = () => {
  return (
    <section className="mt-6 min-h-screen w-full overflow-y-auto overflow-x-hidden pb-2 text-white">
      <BacklogHeader />
      <BacklogContainer />
    </section>
  );
};

export default Backlog;
